import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Ruler } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SizeChart } from '../components/SizeChart';

export const SizeGuidePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50/50 to-white">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-[#7d1f3d]">
              CurveeForYou
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-[#7d1f3d] text-[#7d1f3d] hover:bg-[#7d1f3d] hover:text-white">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Shop
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-5xl font-bold text-[#7d1f3d] mb-6">Size Guide</h1>
        <p className="text-xl text-gray-600 mb-12">Find your perfect fit</p>

        <div className="space-y-8">
          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <div className="flex items-start gap-4 mb-6">
              <div className="bg-[#7d1f3d]/10 p-3 rounded-lg">
                <Ruler className="w-6 h-6 text-[#7d1f3d]" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#7d1f3d] mb-3">How to Choose the Right Fit</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  For the best result, compare your bust, waist, and hip measurements to the size chart below before ordering. If you are between sizes or prefer a more relaxed feel for everyday wear, sizing up may be the better option.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  CurveeForYou combines shaping support with wearable comfort, so finding the right fit is important for all-day confidence.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <h2 className="text-2xl font-bold text-[#7d1f3d] mb-6">How to Measure</h2>
            <div className="space-y-4 text-gray-600">
              <div>
                <h3 className="font-semibold text-[#7d1f3d] mb-2">Bust</h3>
                <p>Measure around the fullest part of your bust, keeping the tape parallel to the floor.</p>
              </div>
              <div>
                <h3 className="font-semibold text-[#7d1f3d] mb-2">Waist</h3>
                <p>Measure around your natural waistline, typically the narrowest part of your torso.</p>
              </div>
              <div>
                <h3 className="font-semibold text-[#7d1f3d] mb-2">Hips</h3>
                <p>Measure around the fullest part of your hips, keeping the tape parallel to the floor.</p>
              </div>
            </div>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <h2 className="text-2xl font-bold text-[#7d1f3d] mb-6">Size Chart</h2>
            <SizeChart />
          </div>

          <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6">
            <h3 className="font-bold text-[#7d1f3d] mb-2">💡 Sizing Tip</h3>
            <p className="text-gray-700">
              If you&apos;re between sizes, we recommend sizing up for a more comfortable fit, especially if this is your first time wearing shapewear. You can always exchange if needed!
            </p>
          </div>
        </div>
      </main>

      <footer className="bg-[#7d1f3d] text-white py-8 mt-16">
        <div className="container mx-auto px-6 text-center">
          <div className="flex flex-wrap justify-center gap-6 mb-4">
            <Link to="/faq" className="hover:text-[#d4af37] transition-colors">FAQ</Link>
            <Link to="/shipping" className="hover:text-[#d4af37] transition-colors">Shipping</Link>
            <Link to="/returns" className="hover:text-[#d4af37] transition-colors">Returns</Link>
            <Link to="/size-guide" className="hover:text-[#d4af37] transition-colors">Size Guide</Link>
            <Link to="/contact" className="hover:text-[#d4af37] transition-colors">Contact</Link>
          </div>
          <div className="text-sm opacity-90 mb-3 leading-relaxed">
            <p className="font-semibold mb-1">CurveeForYou</p>
            <p>1209 Mountain Road Place Northeast, Suite N</p>
            <p>Albuquerque, NM 87110, United States</p>
            <p className="mt-2">
              <a href="tel:+18002985173" className="hover:text-[#d4af37] transition-colors">Tel: 800 298 5173</a>
              {' · '}
              <a href="mailto:info@curveeforyou.com" className="hover:text-[#d4af37] transition-colors">info@curveeforyou.com</a>
            </p>
          </div>
          <p className="text-sm opacity-80">© 2025 CurveeForYou. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};
